import React from 'react'
import { Seo } from '~/components/molecules/Seo'
import { Screen } from '~/components/screens/avit'
import { site } from '~/config'

const Page = () => (
  <>
    <Seo
      title={`Avit | ${site.title}`}
      description={
        'Avit is a programmatically compliant, bank-issued token pegged 1:1 to the US dollar: a tokenized deposit within the Hazel Network, designed to be a GENIUS Act regulated payment stablecoin beyond it.'
      }
    />
    <Screen />
  </>
)

export default Page
